var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#D32142"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.14565 18C6.91912 18.0005 6.69756 17.9337 6.50907 17.808C6.32059 17.6823 6.17368 17.5035 6.087 17.2941C6.00032 17.0848 5.97777 16.8545 6.02222 16.6323C6.06667 16.4101 6.17611 16.2062 6.33665 16.0463L16.0458 6.33517C16.152 6.22891 16.2781 6.14462 16.4169 6.08711C16.5557 6.0296 16.7045 6 16.8547 6C17.005 6 17.1538 6.0296 17.2926 6.08711C17.4314 6.14462 17.5575 6.22891 17.6637 6.33517C17.77 6.44143 17.8543 6.56758 17.9118 6.70642C17.9692 6.84525 17.9988 6.99406 17.9988 7.14434C17.9988 7.29461 17.9692 7.44342 17.9118 7.58225C17.8543 7.72109 17.77 7.84724 17.6637 7.9535L7.95464 17.6647C7.84868 17.7713 7.72261 17.8558 7.58374 17.9134C7.44487 17.971 7.29597 18.0004 7.14565 18Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8544 18C16.7041 18.0002 16.5553 17.9706 16.4165 17.9131C16.2776 17.8555 16.1515 17.7711 16.0454 17.6647L6.33632 7.9535C6.23008 7.84724 6.14581 7.72109 6.08831 7.58225C6.03081 7.44342 6.00122 7.29461 6.00122 7.14434C6.00122 6.99406 6.03081 6.84525 6.08831 6.70642C6.14581 6.56758 6.23008 6.44143 6.33632 6.33517C6.44256 6.22891 6.56868 6.14462 6.70749 6.08711C6.8463 6.0296 6.99507 6 7.14531 6C7.29556 6 7.44433 6.0296 7.58314 6.08711C7.72195 6.14462 7.84807 6.22891 7.95431 6.33517L17.6634 16.0463C17.824 16.2062 17.9334 16.4101 17.9778 16.6323C18.0223 16.8545 17.9997 17.0848 17.9131 17.2941C17.8264 17.5035 17.6795 17.6823 17.491 17.808C17.3025 17.9337 17.0809 18.0005 16.8544 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedCross);
export default __webpack_public_path__ + "static/media/RedCross.1fed8e0a4ff76048a94f6d9e0802dee6.svg";
export { ForwardRef as ReactComponent };